<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">用户管理</div>
			<div class="right">
				<el-button size="mini" @click="refreshUser">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="box">
							<div class="label">用户查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small" clearable>
									<el-select v-model="query.keytype" slot="prepend" placeholder="请选择">
										<el-option label="按ID" value="id"></el-option>
										<el-option label="按手机号" value="phone"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="15">
						<el-button type="primary" icon="el-icon-search" style="width: 6rem;" size="small"
							@click="searchUser">搜索
						</el-button>
						<el-button size="small" @click="resetSearchUser">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-operate">
			<el-button :disabled="coupon_disabled" @click="couponUser" size="small">
				<i class="el-icon-s-ticket"></i>
				<span>发放优惠券</span>
			</el-button>
			<el-button :disabled="coin_disabled" @click="coinUser" size="small">
				<i class="el-icon-coin"></i>
				<span>增减财务</span>
			</el-button>
		</div>
		<div class="grid-content-list member">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col width="16%">
						<col width="10%">
						<col width="9%">
						<col width="9%">
						<col width="9%">
						<col width="9%">
						<col width="15%">
						<col>
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>用户</th>
							<th>余额</th>
							<th>代币</th>
							<th>优惠券</th>
							<th>总订单</th>
							<th>注册来源</th>
							<th>注册时间</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col width="16%">
						<col width="10%">
						<col width="9%">
						<col width="9%">
						<col width="9%">
						<col width="9%">
						<col width="15%">
						<col>
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="9"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox v-model="item.checked" @change="checkboxUser">
										</el-checkbox>
									</div>
								</td>
								<td>
									<div class="user">
										<img v-if="item.head" :src="item.head" class="avatar">
										<img v-else src="../../assets/custom_head.png" class="avatar">
										<div class="info">
											<div v-if="item.phone" class="name link">
												{{item.phone}}
											</div>
											<div v-else class="name">
												{{item.nickname?item.nickname:'null'}}
											</div>
											<div class="id">ID:{{item.uid}}</div>
										</div>
										<div class="grade">
											<div class="bg"></div>
											<div class="text">普通</div>
										</div>
									</div>
								</td>
								<td>
									<div class="amount">{{item.amount}}</div>
								</td>
								<td>
									<div class="print">
										<div class="box">
											<div class="num">{{item.print}}</div>
											<div class="unit">个</div>
										</div>
									</div>
								</td>
								<td>
									<div class="coupon">
										<div class="box">
											<div class="num link">{{item.coupon}}</div>
											<div class="unit">张</div>
										</div>
									</div>
								</td>
								<td>
									<div class="order">
										<div class="box">
											<div class="num link" @click="orderUser(item.uid)">
												{{item.order_total}}
											</div>
											<div class="unit">笔</div>
										</div>
									</div>
								</td>
								<td>
									<div style="text-align: center;">-</div>
								</td>
								<td>
									<div class="reg-day">
										<div class="num">{{item.reg_day}}</div>
										<div class="unit">天</div>
									</div>
									<div class="reg-time">{{item.reg_time}}</div>
								</td>
								<td>
									<div class="operate">
										<el-button plain size="mini" disabled>修改手机
										</el-button>
										<el-button type="danger" plain size="mini" :loading="item.del_loading"
											@click="blackUser(index)">
											封禁
										</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageUser">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无用户数据" :image-size="100">
			</el-empty>
		</div>
		<el-drawer title="发放优惠券" :visible.sync="drawer_coupon.show">
			<div class="drawer coupon">
				<el-alert title="仅允许发放内部优惠券，如果不能发放，请检查库存或条件" type="warning" show-icon :closable="false">
				</el-alert>
				<div class="content" v-loading="(drawer_coupon.form.cid<=0 && drawer_coupon.loading)?true:false">
					<div v-for="(item,index) in drawer_coupon.list" :key="index" class="box">
						<div class="radio">
							<el-radio v-model="drawer_coupon.form.cid" :label="item.id"
								@change="changeCouponUser(item.maxNum)">选择</el-radio>
						</div>
						<div class="item">
							<div class="flex">
								<div class="flex-hd">
									<div class="a">{{item.amount}}</div>
									<div class="b">{{item.type}}</div>
								</div>
								<div class="flex-bd">
									<div class="a">{{item.title}}</div>
									<div class="b">{{item.outTime}}</div>
								</div>
							</div>
							<div class="flex-bt">
								<div class="text">{{item.desc}}</div>
							</div>
							<div class="stock">{{item.stock}}</div>
						</div>
					</div>
				</div>
				<div class="drawer-footer">
					<div class="l">发放量</div>
					<div class="num">
						<el-input-number v-model="drawer_coupon.form.num" :min="1" :max="drawer_coupon.form.max"
							size="small" controls-position="right" :disabled="drawer_coupon.form.cid>0?false:true">
						</el-input-number>
					</div>
					<el-button type="primary" @click="grantCouponUser"
						:loading="(drawer_coupon.form.cid>0 && drawer_coupon.loading)?true:false"
						:disabled="drawer_coupon.form.cid>0?false:true">确认发放</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: [],
				coin_disabled: true,
				coupon_disabled: true,
				drawer_coupon: {
					show: false,
					loading: false,
					list: [],
					form: {
						uid: 0,
						cid: 0,
						num: 1,
						max: 1
					}
				}
			};
		},
		created() {
			this.postUser();
		},
		methods: {
			checkboxUser() {
				const that = this;
				const list = that.list;
				that.coupon_disabled = true;
				var checkedNum = 0;
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						checkedNum++;
					}
				}
				if (checkedNum == 1) {
					that.coupon_disabled = false;
				}
			},
			searchUser() {
				const that = this;
				const query = Object.keys(that.query);
				if (query.length <= 0) {
					that.$message.error("错误：至少需要一个搜索项");
				} else {
					if (that.query.keyword && that.query.keytype == undefined) {
						that.$message.error("错误：请选择关键字类型");
						return;
					}
					if (that.query.keyword == undefined && that.query.keytype) {
						that.$message.error("错误：请输入搜索关键字");
						return;
					}
					that.pageUser(1);
				}
			},
			resetSearchUser() {
				this.query = {};
				this.pageUser(1);
			},
			coinUser() {

			},
			couponUser() {
				const that = this;
				that.drawer_coupon.show = true;
				that.drawer_coupon.loading = true;
				that.drawer_coupon.list = [];
				that.drawer_coupon.form = that.$options.data().drawer_coupon.form;
				for (var i = 0; i < that.list.length; i++) {
					if (that.list[i].checked) {
						that.drawer_coupon.form.uid = that.list[i].uid;
						break;
					}
				}
				that.$post('marketingCoupon', {
					mode: "user",
					uid: that.drawer_coupon.form.uid,
				}).then(res => {
					setTimeout(function() {
						that.drawer_coupon.loading = false;
						that.drawer_coupon.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.drawer_coupon.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			changeCouponUser(maxNum) {
				this.drawer_coupon.form.num = 1;
				this.drawer_coupon.form.max = maxNum;
			},
			grantCouponUser() {
				const that = this;
				that.drawer_coupon.loading = true;
				that.$post('marketingCoupon', {
					mode: "grant",
					uid: that.drawer_coupon.form.uid,
					cid: that.drawer_coupon.form.cid,
					num: that.drawer_coupon.form.num
				}).then(res => {
					setTimeout(function() {
						that.drawer_coupon.show = false;
						that.$message.success("操作成功");
						that.pageUser(1);
					}, 1000);
				}).catch(e => {
					that.drawer_coupon.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			orderUser(id) {
				this.$router.push({
					name: "order_list_all",
					params: {
						query: {
							keytype: "user",
							keyword: id
						}
					}
				});
			},
			blackUser(index, type) {
				const that = this;
				const ss = (type == 1) ? "解禁后可以继续在您的区域下单" : "封禁后不可以在您的区域下单";
				that.$confirm(ss + '，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.list[index].del_loading = true;
					that.$post('user', {
						mode: "del",
						id: that.list[index].id
					}).then(res => {
						setTimeout(function() {
							that.$message.success("操作成功");
							that.list[index].del_loading = false;
							that.pageUser(1);
						}, 500);
					}).catch(e => {
						that.list[index].del_loading = false;
						that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
							"未知错误，请重试", '提示', {
								type: 'error',
								confirmButtonText: '确定'
							});
					});
				}).catch(() => {});
			},
			refreshUser() {
				this.pageUser(1);
			},
			pageUser(e) {
				this.page = e;
				this.postUser(this.query);
			},
			postUser(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('user', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.coupon_disabled = true;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							item.del_loading = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.member .user {
		display: flex;
		align-items: center;
		padding: 10px;
		position: relative;
	}

	.member .user .avatar {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.375rem;
	}

	.member .user .info {
		margin-left: 0.3125rem;
	}

	.member .user .info .name {
		font-size: 0.875rem;
		font-weight: bold;
		color: #576b95
	}

	.member .user .info .id {
		color: #666;
		margin-top: 0.3rem;
		font-size: 0.75rem;
	}

	.member .user .grade {
		position: absolute;
		top: -0.125rem;
		left: -0.125rem;
	}

	.member .user .grade .bg {
		border-left: 2.5rem solid #7b7e93;
		border-bottom: 2.5rem solid transparent;
	}

	.member .user .grade .text {
		position: absolute;
		top: 0.3125rem;
		left: 0;
		color: white;
		font-weight: bold;
		text-align: center;
		font-size: 0.75rem;
		transform: scale(.8);
		transform: rotate(-45deg);
	}

	.member .amount,
	.member .print,
	.member .coupon,
	.member .order,
	.member .reg-day,
	.member .reg-time,
	.member .operate {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.875rem;
	}

	.member .print .box,
	.member .coupon .box,
	.member .order .box {
		display: flex;
		align-items: baseline;
	}

	.drawer.coupon .content {
		padding: 20px 20px 5px 20px;
		box-sizing: border-box;
	}

	.drawer.coupon .content .box {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}

	.drawer.coupon .content .box .radio {
		margin-right: 15px;
	}

	.drawer.coupon .content .box .radio .el-radio {
		transform: scale(1.3);
	}

	.drawer.coupon .content .box .radio>>>.el-radio__label {
		display: none;
	}

	.drawer.coupon .content .box .radio>>>.el-radio__input.is-checked .el-radio__inner {
		border-color: #e31436;
		background: #e31436;
	}

	.drawer.coupon .content .box .item {
		flex: 1;
		position: relative;
		overflow: hidden;
		border-radius: 8px;
		background-color: rgba(212, 0, 0, 0.06);
	}

	.drawer.coupon .content .box .item .flex {
		display: flex;
		align-items: center;
		position: relative;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		border: 1px solid #f3d4d4;
		border-bottom: 0;
	}

	.drawer.coupon .content .box .item .flex .flex-hd {
		color: #333333;
		text-align: center;
		padding: 10px 30px;
		border-right: 1px dashed #f3c9c7;
	}

	.drawer.coupon .content .box .item .flex .flex-hd .a {
		color: #DD524D;
		font-size: 30px;
		font-weight: bold;
		line-height: 35px;
	}

	.drawer.coupon .content .box .item .flex .flex-hd .b {
		font-size: 12px;
	}

	.drawer.coupon .content .box .item .flex .flex-bd {
		flex: 1;
		min-width: 0;
		padding: 0 10px;
	}

	.drawer.coupon .content .box .item .flex .flex-bd .a {
		display: flex;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.drawer.coupon .content .box .item .flex .flex-bd .a text {
		color: #fff;
		font-size: 10px;
		padding: 1px 4px;
		font-weight: 300;
		border-radius: 2px;
		margin-right: 5px;
		background: #f03856;
	}

	.drawer.coupon .content .box .item .flex .flex-bd .b {
		color: #666;
		font-size: 12px;
	}

	.drawer.coupon .content .box .item .flex-bt {
		position: relative;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		border: 1px solid #f3d4d4;
		border-top: 1px dashed #f3c9c7;
	}

	.drawer.coupon .content .box .item .flex-bt::after,
	.drawer.coupon .content .box .item .flex-bt::before {
		position: absolute;
		top: -8px;
		content: "";
		width: 15px;
		height: 15px;
		border-radius: 50%;
		background-color: white;
		border: 1px solid #f3d4d4;
	}

	.drawer.coupon .content .box .item .flex-bt::after {
		left: -10px;
	}

	.drawer.coupon .content .box .item .flex-bt::before {
		right: -10px;
	}

	.drawer.coupon .content .box .item .flex-bt .text {
		padding: 5px 10px;
		width: 100%;
		color: #999;
		display: block;
		font-size: 12px;
		position: relative;
		box-sizing: border-box;
	}

	.drawer.coupon .content .box .item .stock {
		position: absolute;
		top: 0;
		right: 0;
		color: #5e2a2a;
		font-size: 0.75rem;
		padding: 0.125rem 0.625rem;
		background: #f3d4d4;
		border-bottom-left-radius: 0.5rem;
	}

	.drawer.coupon .drawer-footer {
		font-size: 0.875rem;
		align-items: center;
		border-top: 1px #f0f0f0 solid;
	}

	.drawer.coupon .drawer-footer .l {
		margin-right: 10px;
	}

	.drawer.coupon .drawer-footer .num {
		width: 7rem;
		margin-right: 10px;
	}

	.drawer.coupon .drawer-footer .num .el-input-number {
		width: 100%;
	}
</style>
